/* Galería deslizable: convierte la foto principal en un carrusel que se pasa con el dedo. */
(function () {
  var css = '.gallery__wrap{position:relative}' +
    '.gallery__track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain}' +
    '.gallery__track::-webkit-scrollbar{display:none}' +
    '.gallery__track>img{flex:0 0 100%;min-width:0;scroll-snap-align:start;scroll-snap-stop:always}' +
    '.gallery__count{position:absolute;right:12px;bottom:12px;background:rgba(42,36,32,.72);color:#fff;font-size:12px;font-weight:700;padding:4px 10px;border-radius:999px;pointer-events:none}' +
    '.gallery__nav{position:absolute;top:50%;transform:translateY(-50%);width:40px;height:40px;border-radius:999px;border:0;background:rgba(255,255,255,.92);color:#2A2420;font-size:20px;line-height:1;cursor:pointer;display:none;align-items:center;justify-content:center}' +
    '.gallery__nav--prev{left:10px}.gallery__nav--next{right:10px}' +
    '@media (min-width:990px){.gallery__nav{display:flex}.gallery__track{border-radius:20px}.gallery__track>img{border-radius:0}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function init(gallery) {
    var main = gallery.querySelector('.gallery__main');
    var oldThumbs = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__thumb'));
    if (!main || oldThumbs.length < 2 || gallery.querySelector('.gallery__track')) return;

    // Clonar las miniaturas para quitar el comportamiento antiguo (cambiar la foto fija)
    var thumbs = oldThumbs.map(function (t) {
      var c = t.cloneNode(true);
      t.parentNode.replaceChild(c, t);
      return c;
    });

    var wrap = document.createElement('div');
    wrap.className = 'gallery__wrap';
    var track = document.createElement('div');
    track.className = 'gallery__track';
    track.setAttribute('aria-label', 'Fotos del producto');
    main.parentNode.insertBefore(wrap, main);
    wrap.appendChild(track);

    var start = 0;
    thumbs.forEach(function (t, i) {
      if (t.getAttribute('aria-current') === 'true') start = i;
    });
    thumbs.forEach(function (t, i) {
      var img;
      if (i === start) {
        img = main;
      } else {
        img = document.createElement('img');
        img.className = main.className;
        img.loading = 'lazy';
        img.src = t.getAttribute('data-src');
        img.alt = t.getAttribute('data-alt') || '';
      }
      img.removeAttribute('data-gallery-main');
      track.appendChild(img);
    });

    var count = document.createElement('div');
    count.className = 'gallery__count';
    wrap.appendChild(count);

    function current() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(thumbs.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }
    function sync() {
      var i = current();
      count.textContent = (i + 1) + ' / ' + thumbs.length;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }

    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery__nav gallery__nav--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Foto anterior' : 'Foto siguiente');
      b.textContent = dir === 'prev' ? '‹' : '›';
      b.addEventListener('click', function () { go(current() + (dir === 'prev' ? -1 : 1), true); });
      wrap.appendChild(b);
    });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i, true); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    });
    window.addEventListener('resize', function () { go(current(), false); });

    go(start, false);
    sync();
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gallery], .gallery'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
